<template>
    <div class="highlighted-result">
        <span v-text="resource.label" class="highlighted-result__title"/>
        <span v-html="resource.snippet" class="highlighted-result__content"/>
    </div>
</template>
<script>
export default {
    name: 'HighlightResult',
    props: {
        resource: {
            type: Object,
            required: true,
        },
    },
}
</script>
<style lang="scss">
@import '~@/theme/_variables.scss';

.highlighted-result {
    color: $text;
    display: flex;
    flex-direction: column;
    row-gap: .4rem;

    & + & {
        margin-top:1rem;
    }

    .highlighted-result__title {
        font-size: 1.4rem;
        font-weight: 600;
        color: #000;
    }

    .highlighted-result__content {
        font-size: 1.3rem;
    }
}
</style>
